module.exports = __webpack_public_path__ + "img/ywt_list_img5.be40963.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/ywt_list_img5.png
// module id = mOye
// module chunks = 136